const products = [
  { name: "Llave de paso 1/2\"", img: "https://bizor-docs.s3.us-east-2.amazonaws.com/comercial-ac2025/ESSO-1-2.jpg" },
  { name: "Teflón", img: "https://bizor-docs.s3.us-east-2.amazonaws.com/comercial-ac2025/teflon_tape.jpg" },
  { name: "Interruptor doble", img: "https://bizor-docs.s3.us-east-2.amazonaws.com/comercial-ac2025/PRE16047.jpg" },
  { name: "Guantes antiácido", img: "https://bizor-docs.s3.us-east-2.amazonaws.com/comercial-ac2025/Guantes.jpg" }
];

function Gallery() {
  return (
    <section className="container py-5">
      <h2 className="text-center mb-4">Galería de Productos</h2>
      <div className="row">
        {products.map((prod, i) => (
          <div className="col-md-3 col-sm-6 mb-4" key={i}>
            <div className="card h-100 text-center">
              <img src={prod.img} className="card-img-top" alt={prod.name} />
              <div className="card-body">
                <p className="card-text">{prod.name}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Gallery;